import styled from 'styled-components';



export const TableComponentStyle = styled.div`
  width: 100%;
  border-collapse: collapse;
`;
